var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tuango-base-line-chart',{attrs:{"provider":_vm.dataProviderAccepted,"title":"Accepted transactions","color":"#2ecc71"}}),_vm._v(" "),_c('tuango-base-line-chart',{attrs:{"provider":_vm.dataProviderRejected,"title":"Rejected Transactions","color":"#e74c3c"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a82c4fc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/happypack/loader.js?id=eslint!./src/app/pages/Metrics/Transactions.vue
// module id = 717
// module chunks = 1